import './TermsAndConditionsPage.less';
import React, { useContext } from 'react';
import { useQueryParam, StringParam } from 'use-query-params';
import TermsAndConditionsBackupNinja from './termsAndPolicy/TermsAndConditionsBackupNinja';
import TermsAndConditionsVendorExoscale from './termsAndPolicy/TermsAndConditionsVendorExoscale';
import TermsAndConditionsCCX from './termsAndPolicy/TermsAndConditionsCcx';
import { APP_CCX, CustomAppContext } from '../common/CustomAppContext';

export default TermsAndConditionsPage;

/**
 * @name TermsAndConditionsPage
 * @desc TermsAndConditionsPage component.
 */
function TermsAndConditionsPage() {
    const [origin] = useQueryParam('origin', StringParam);
    const [from] = useQueryParam('from', StringParam);
    const { currentApp } = useContext(CustomAppContext);

    const renderContent = () => {
        switch (origin || from || window?.FEAS_ENV?.REACT_APP_CURRENT_APP) {
            case 'exoscale':
                return <TermsAndConditionsVendorExoscale />;
            case 'cm':
                return <TermsAndConditionsBackupNinja />;
            case 'ccx':
                return <TermsAndConditionsCCX />;
            case 'bn':
            default:
                return <TermsAndConditionsBackupNinja />;
        }
    };
    return <div className="TermsAndConditionsPage">{renderContent()}</div>;
}
